<template>
  <div class="collect-requirement-list-container man-requirement-c">
    <requirements-list
      :requirements="lists"
      theme="collect-list"
      :isShowPagination="paginationConfig"
      :hasChild="false"
      :demand_mold_id="demand_mold_id"
      @onChild="getChildLists"
    ></requirements-list>
  </div>
</template>

<script>
import RequirementsList from '@/pages/requirement/_list.vue';
import { getMaterialDemandList, getMaterialDemandChildList } from '@/api/user';

export default {
  components: {
    RequirementsList,
  },
  data() {
    return {
      lists: [],
      pageSize: 10,
      paginationConfig: {},
      demand_mold_id: 0,
      hasChild: true,
    };
  },
  computed: {
    page() {
      return this.$route.query.page || 1;
    },
  },
  watch: {
    $route: {
      handler: 'init',
      immediate: true,
    },
  },
  methods: {
    init() {
      // 获取数据
      if(this.$route.query.demand_mold_id && this.$route.query.demand_mold_id != 0) {
        //不做
        this.getChildLists(Number(this.$route.query.demand_mold_id))
      }else{
        this.getLists();
      }
      console.log(this.$route.query.demand_mold_id, this.demand_mold_id)
    },
    async getLists() {
      this.hasChild = true
      this.demand_mold_id = 0
      this.$store.commit('openLoading');
      const res = await getMaterialDemandList({
        page: this.page,
        page_size: this.pageSize,
      });
      const { data } = res;
      this.lists = data.list;
      this.paginationConfig.page_num = data.total || 0
      // this.$emit('counts', data.total.num);
      this.$store.commit('closeLoading');
      console.log(this.paginationConfig.num , 99)
    },
    async getChildLists(demand_mold_id) {
      this.hasChild = false
      this.demand_mold_id = demand_mold_id
      this.$store.commit('openLoading');
      const res = await getMaterialDemandChildList({
        page: this.page,
        page_size: this.pageSize,
        demand_mold_id: this.demand_mold_id
      });
      const { data } = res;
      this.lists = data.list;
      this.paginationConfig.page_num = data.total || 0
      // this.$emit('counts', data.total.num);
      this.$store.commit('closeLoading');
    },
  },
};
</script>

<style>
  .man-requirement-c {
    padding: 1.71875vw 0;
  }
</style>
